const base = (size) => ({
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  width: size,
  height: size,
});

export function EmailOpenedIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <path d="M22 8L12 3 2 8v11a2 2 0 002 2h16a2 2 0 002-2V8z" />
      <path d="M2 8l10 7 10-7" />
    </svg>
  );
}

export function PageViewedIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function IsInterestedIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  );
}

export function AskQuestionIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
  );
}

export function UnsubscribedIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );
}

export function EmailBouncedIcon({ size = 20 }) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16" x2="12" y2="16.5" />
    </svg>
  );
}
